import type { EntityType } from "../redux/global-map.types"

const PREFIX_TO_ENTITY: Record<string, EntityType> = { p: "project", l: "lead" }
const ENTITY_TO_PREFIX: Record<EntityType, string> = { project: "p", lead: "l" }

export function parseFeatureId(featureId: string): {
  entityType: EntityType
  id: string
} {
  const [prefix, ...rest] = featureId.split(":")
  const entityType = PREFIX_TO_ENTITY[prefix]
  if (!entityType) {
    throw new Error(`Unrecognized feature id prefix: ${featureId}`)
  }
  return { entityType, id: rest.join(":") }
}

// The inverse of `parseFeatureId` — a search result comes back as a bare
// uuid (`ProjectQuickView`/`LeadQuickView`'s own `id`, same shape the quick
// view detail endpoints already use), but `selectFeature`/`?feature=` both
// key on the namespaced form `data.features` itself uses.
export function buildFeatureId(entityType: EntityType, id: string): string {
  return `${ENTITY_TO_PREFIX[entityType]}:${id}`
}
